/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateTransactionUpperLimitForTheUserAccount200ResponseReissueOneOf
 */
export interface UpdateTransactionUpperLimitForTheUserAccount200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseReissueOneOf
     */
    'cardType': UpdateTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const UpdateTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type UpdateTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum = typeof UpdateTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum[keyof typeof UpdateTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum];


